import { AuthenticationModal } from "domains/authentication/components/AuthenticationModal";
import { UnauthenticatedModal } from "domains/authentication/components/UnauthenticatedModal";
import { BriefingModal } from "domains/briefing/components/BriefingModal/BriefingModal";
import { AllCoachmarksModal } from "domains/coachmarks/components/AllCoachmarksModal";
import { CoachmarksSettingsModal } from "domains/coachmarks/components/CoachmarksSettingsModal";
import { ConfirmResetCoachmarksModal } from "domains/coachmarks/components/ConfirmResetCoachmarksModal";
import { CollectionCancellationConfirmationModal } from "domains/collection/modals/CollectionCancellationConfirmationModal";
import { CollectionCreateCoCuratorModal } from "domains/collection/modals/CollectionCreateCoCuratorModal";
import { CollectionDeletionConfirmationModal } from "domains/collection/modals/CollectionDeletionConfirmationModal";
import { CollectionHeroImagePickerModal } from "domains/collection/modals/CollectionHeroImagePickerModal";
import { MapImagePickerModal } from "domains/createMapDetail/components/image/MapImagePickerModal";
import { DimensionsModal } from "domains/createMapDetail/components/keyIssueList/DimensionsModal";
import { CancelMapModal } from "domains/createMapDetail/components/modals/CancelMapModal";
import { ConfirmDeleteMapModal } from "domains/createMapDetail/components/modals/ConfirmDeleteMapModal";
import { ConfirmRemoveCollaboratorModal } from "domains/createShareSettings/components/ConfirmRemoveCollaboratorModal";
import { MapShareLinkModal } from "domains/createShareSettings/components/MapShareLinkModal";
import { OpenLinkInvitationModal } from "domains/createShareSettings/components/OpenLinkInvitationModal";
import { AddCustomContentModal } from "domains/customContentAndSources/components/AddCustomContentModal";
import { AddCustomDimensionModal } from "domains/customKeyIssue/components/AddCustomDimensionModal";
import { IncidentsModal } from "domains/incidents/components/IncidentsModal";
import { ChangeLanguageModal } from "domains/language/components/ChangeLanguageModal";
import { CreateCustomDimensionUpgradeModal } from "domains/modal/components/CreateCustomDimensionUpgradeModal";
import { CreateMapUpgradeModal } from "domains/modal/components/CreateMapUpgradeModal";
import { ErrorModal } from "domains/modal/components/ErrorModal";
import { AddSourceFormModal } from "domains/moderate/sources/components/AddSourceFormModal/AddSourceFormModal";
import { ConfirmCloseEditSourceFormModal } from "domains/moderate/sources/components/ConfirmCloseEditSourceFormModal/ConfirmCloseEditSourceFormModal";
import { ConfirmDeleteSourceModal } from "domains/moderate/sources/components/ConfirmDeleteSourceModal/ConfirmDeleteSourceModal";
import { FilterSourceListModal } from "domains/moderate/sources/components/FilterSourceListModal/FilterSourceListModal";
import { ManageTopicsModal } from "domains/monitor/filter/components/ManageTopicsModal";
import { MonitorFilterModal } from "domains/monitor/filter/components/MonitorFilterModal";
import { NotificationDetailModal } from "domains/notifications/components/NotificationDetailModal";
import { NotificationsModal } from "domains/notifications/components/NotificationsModal";
import { NotificationsSettingsModal } from "domains/notifications/components/NotificationsSettingsModal";
import { AddKnowledgeModal } from "domains/pinAddReject/components/AddKnowledgeModal/AddKnowledgeModal";
import { KnowledgeRejectionReasonModal } from "domains/pinAddReject/components/KnowledgeRejectionReasonModal";
import { KnowledgeSearchFilterModal } from "domains/search/components/KnowledgeSearchFilterModal";
import { SearchFilterModal } from "domains/search/components/SearchFilterModal";
import { ShareModal } from "domains/share/components/ShareModal";
import { BriefingErrorModal } from "domains/topic/components/BriefingErrorModal";
import { EmbedMapWidgetModal } from "domains/topic/components/EmbedMapWidgetModal";
import { TopicDataFilterModal } from "domains/topicSearchFilter/components/TopicDataFilterModal";
import { TopicEventFilterModal } from "domains/topicSearchFilter/components/TopicEventFilterModal";
import { TopicInitiativeFilterModal } from "domains/topicSearchFilter/components/TopicInitiativeFilterModal";
import { TopicLatestFilterModal } from "domains/topicSearchFilter/components/TopicLatestFilterModal";
import { TopicPublicationFilterModal } from "domains/topicSearchFilter/components/TopicPublicationFilterModal";
import { TopicStakeholderFilterModal } from "domains/topicSearchFilter/components/TopicStakeholderFilterModal";
import { TopicVideoFilterModal } from "domains/topicSearchFilter/components/TopicVideoFilterModal";
import { WhatsNewModal } from "domains/whatsNew/components/WhatsNewModal";

export const modalStack = {
  AddCustomContent: AddCustomContentModal,
  AddCustomDimension: AddCustomDimensionModal,
  AddKnowledge: AddKnowledgeModal,
  AddSourceForm: AddSourceFormModal,
  AllCoachmarks: AllCoachmarksModal,
  Authentication: AuthenticationModal,
  Briefing: BriefingModal,
  BriefingError: BriefingErrorModal,
  CancelMap: CancelMapModal,
  ChangeLanguage: ChangeLanguageModal,
  CoachmarksSettings: CoachmarksSettingsModal,
  CollectionCancellationConfirmation: CollectionCancellationConfirmationModal,
  CollectionCreateCoCurator: CollectionCreateCoCuratorModal,
  CollectionDeletionConfirmation: CollectionDeletionConfirmationModal,
  CollectionHeroImagePicker: CollectionHeroImagePickerModal,
  ConfirmCloseEditSourceForm: ConfirmCloseEditSourceFormModal,
  ConfirmDeleteMap: ConfirmDeleteMapModal,
  ConfirmDeleteSource: ConfirmDeleteSourceModal,
  ConfirmRemoveCollaborator: ConfirmRemoveCollaboratorModal,
  ConfirmResetCoachmarks: ConfirmResetCoachmarksModal,
  CreateCustomDimensionUpgrade: CreateCustomDimensionUpgradeModal,
  CreateMapUpgrade: CreateMapUpgradeModal,
  Dimensions: DimensionsModal,
  EmbedMapWidget: EmbedMapWidgetModal,
  Error: ErrorModal,
  FilterSourceList: FilterSourceListModal,
  Incidents: IncidentsModal,
  KnowledgeRejectionReason: KnowledgeRejectionReasonModal,
  KnowledgeSearchFilter: KnowledgeSearchFilterModal,
  ManageTopics: ManageTopicsModal,
  MapImagePicker: MapImagePickerModal,
  MapShareLink: MapShareLinkModal,
  MonitorFilter: MonitorFilterModal,
  NotificationDetail: NotificationDetailModal,
  Notifications: NotificationsModal,
  NotificationsSettings: NotificationsSettingsModal,
  OpenLinkInvitation: OpenLinkInvitationModal,
  SearchFilter: SearchFilterModal,
  Share: ShareModal,
  TopicDataFilter: TopicDataFilterModal,
  TopicEventFilter: TopicEventFilterModal,
  TopicInitiativeFilter: TopicInitiativeFilterModal,
  TopicLatestFilter: TopicLatestFilterModal,
  TopicPublicationFilter: TopicPublicationFilterModal,
  TopicStakeholderFilter: TopicStakeholderFilterModal,
  TopicVideoFilter: TopicVideoFilterModal,
  Unauthenticated: UnauthenticatedModal,
  WhatsNew: WhatsNewModal,
};
